import { messages } from '@/messages';

// Maps the schema enum codes to user-facing PT-BR labels. Use whenever you
// render a stored value from one of the qualification answer enums.

export const incomeSourceLabel: Record<string, string> = {
  clt: messages.incomeSource_clt,
  self_employed: messages.incomeSource_self_employed,
  business_owner: messages.incomeSource_business_owner,
  retired: messages.incomeSource_retired,
  informal: messages.incomeSource_informal,
  other: messages.incomeSource_other,
};

export const maritalStatusLabel: Record<string, string> = {
  single: messages.maritalStatus_single,
  married: messages.maritalStatus_married,
  divorced: messages.maritalStatus_divorced,
  widowed: messages.maritalStatus_widowed,
  stable_union: messages.maritalStatus_stable_union,
};

export const creditStatusLabel: Record<string, string> = {
  clean: messages.creditStatus_clean,
  restricted: messages.creditStatus_restricted,
  unknown: messages.creditStatus_unknown,
};

export const timelineLabel: Record<string, string> = {
  within_1_month: messages.timeline_within_1_month,
  '1_to_3_months': messages.timeline_1_to_3_months,
  '3_to_6_months': messages.timeline_3_to_6_months,
  '6_plus_months': messages.timeline_6_plus_months,
};

export const funnelStageLabel: Record<string, string> = {
  submitted: 'Recebido',
  contacted: 'Contatado',
  visited: 'Visitou',
  proposal: 'Proposta enviada',
  closed_won: 'Fechado (venda)',
  closed_lost: 'Perdido',
};

export const failedCriterionLabel: Record<string, string> = {
  // MCMV
  income_above_max: messages.criterion_income_above_max,
  income_below_min: messages.criterion_income_below_min,
  under_min_age: messages.criterion_under_min_age,
  already_owns_property: messages.criterion_already_owns_property,
  already_used_mcmv: messages.criterion_already_used_mcmv,
  no_fgts: messages.criterion_no_fgts,
  restricted_credit: messages.criterion_restricted_credit,
  no_down_payment: messages.criterion_no_down_payment,
  no_income_tax_declaration: messages.criterion_no_income_tax_declaration,
  // Proteção veicular
  pv_under_min_age: 'Idade abaixo do mínimo (18 anos)',
  pv_vehicle_too_old: 'Veículo com mais de 25 anos de uso',
  pv_excluded_vehicle_type: 'Tipo de veículo fora da cobertura',
  pv_outside_coverage_area: 'Região fora da área de cobertura atual',
  // Imobiliário geral
  ig_income_below_price: 'Renda abaixo da faixa de valor',
  ig_long_timeline: 'Compra prevista pra 6 a 12 meses',
  ig_just_browsing: 'Só pesquisando por enquanto',
  ig_low_down_payment: 'Entrada abaixo de R$ 40 mil',
};

export const propertyStageLabel: Record<string, string> = {
  ready: 'Pronto pra morar',
  launch: 'Lançamento',
};

export const closedLostReasonLabel: Record<string, string> = {
  no_response: 'Sem resposta',
  no_credit: 'Sem crédito',
  not_interested: 'Não interessado',
  chose_competitor: 'Foi com outro corretor',
  wrong_timing: 'Timing errado',
  other: 'Outro',
};

/** Look up a label by key, falling back to the raw key if not found. */
export function labelOr(map: Record<string, string>, key: unknown): string {
  const k = String(key ?? '');
  return map[k] ?? k;
}
